module.exports = (
  $uibModalInstance,
  $scope,
  source,
  countries,
  canRemove
) ->
  $scope.canRemove = canRemove
  $scope.isNew     = !canRemove

  $scope.ok = () ->
    $uibModalInstance.close({ action: 'Save', customSource: $scope.source })

  $scope.remove = () ->
    $uibModalInstance.close({ action: 'Remove', customSource: $scope.source })

  $scope.cancel = () ->
    $uibModalInstance.dismiss()

  $scope.forms = {}
  $scope.creating = false
  $scope.countries = countries
  $scope.source = source
